module.exports = {
  // UIL_API: "http://127.0.0.1:7754/",
  FILE_API: "http://127.0.0.1:7754/DownloadFile?FileUrl=",
  // AUTH_FILE_API: "http://127.0.0.1:7754/DownloadAuthFile?FileUrl=",
  // URL_KCB_API: "http://127.0.0.1/OKName/",



  REQ_TYPE_VISIT : "Visit",
  REQ_TYPE_PHOTO : "Photo",
  REQ_TYPE_CARRY : "Carry",
  REQ_TYPE_PASS : "Pass",
  REQ_TYPE_MOVE : "Move",
  REQ_TYPE_CMNG : "CMng",

  REQ_TYPE_VISIT_STATE_REQ : "REQ",
  REQ_TYPE_VISIT_STATE_OK : "OK",

  REQ_TYPE_PHOTO_STATE_REQ : "R",
  REQ_TYPE_PHOTO_STATE_OK : "A",

  REQ_TYPE_CARRY_STATE_REQ : "R",
  REQ_TYPE_CARRY_STATE_OK : "O",

  REQ_TYPE_PASS_STATE_REQ : "R",
  REQ_TYPE_PASS_STATE_OK : "O",
  
  REQ_TYPE_MOVE_STATE_REQ : "R",
  REQ_TYPE_MOVE_STATE_OK : "O",
  
  REQ_TYPE_CCORP_STATE_REQ : "R",
  REQ_TYPE_CCORP_STATE_OK : "O",

  ERROR_CODE_CHECK_RIGHT_CUSTOM : "02",

  DEFAULT_SITE : "",

  TEST_MODE : false,
};